// 菜单跳转url映射
let urlTypeMap = {
    SingleProduct: 101,         // 单个产品
    MultipleProduct: 102,       // 多个产品
    SingleRights: 103,          // 权益商品
    MultipleRights: 104,        // 多个权益/权益产品
    AllProduct: 105,            // 全部产品
    AllRights: 106,             // 全部权益
    PhysicalPackage: 107,       // 体检套餐
    HealthProduct: 108,         // 健康产品
    PhysicalOrder: 403,         // 体检订单
    ReportManagement: 404,      // 报告管理
    HealthRecord: 405,          // 健康档案
    ReportAnalysis: 406,        // 报告解读
    PersonManagement: 407,      // 受检人管理
    PrivacyProtect: 601,        // 隐私保护
    Address: 602,               // 收货地址
    Feedback: 603,              // 意见反馈
    AccountSetting: 604,        // 账号设置
    CouponManagement: 605,      // 优惠券管理
    ExchangeCenter: 606,        // 兑换中心
    CustomUrl: 3,               // 自定义链接
    WxMiniProgram: 5,           // 微信小程序
    CouponInfo: 7,              // 优惠券

}

/**
 * 公用方法-页面跳转
 */
export default function onPageTo(item: any, that: any)
{
    if (!localStorage.getItem("userInfo"))
    {
        that.$router.push({name:"login", query:{redirect: location.href}});
        return;
    }
    
    if (!item.type)
    {
        return;
    }
    if (item.type == urlTypeMap.SingleProduct)   // 单个产品
    {
        if (item.dataList && item.dataList.length > 0)
        {
            let productType = item.dataList[0].productType;
            let data = item.dataList[0];
            if(productType == 0)
            {
                // 体检套餐
                that.$router.push({name: "package-detail", query:{id: data.targetId, productId: data.id}});
            }
            else if(productType == 4)
            {
                // 实物套餐
                that.$router.push({name: "goodsDetail", query:{id: data.targetId, productId: data.id}});
            }
            else if(productType == 8)
            {
                // 健康险产品
                that.$router.push({name: "healthInsuranceDetail", query:{id: data.targetId}});
            }
            else
            {
                that.$router.push({name:"medical", query:{id: data.targetId, productId: data.id}});
            }
        }
    }
    else if (item.type == urlTypeMap.MultipleProduct || item.type ==  urlTypeMap.AllProduct)  // 多个/全部产品/健康产品
    {
        // 数据主键id集合
        let ids = [];
        // 数据所属二级类别集合
        let categoryIds = [];
        if (item.dataList && item.dataList.length) {
            item.dataList.forEach(element => {
                ids.push(element.id);
                !categoryIds.includes(element.subProductType) && categoryIds.push(element.subProductType);
            });
            // 全部产品
            localStorage.setItem("allProductList", JSON.stringify(ids));
            localStorage.setItem("allProductCategoryIds", JSON.stringify(categoryIds));
        }
        else {
            localStorage.setItem("allProductList", null);
            localStorage.setItem("allProductCategoryIds", null);
        }
        if (ids.length === 1) {
            let productType = item.dataList[0].productType;
            let data = item.dataList[0];
            if(productType == 0)
            {
                // 体检套餐
                that.$router.push({name: "package-detail", query:{id: data.targetId, productId: data.id}});
            }
            else if(productType == 4)
            {
                // 实物套餐
                that.$router.push({name: "goodsDetail", query:{id: data.targetId, productId: data.id}});
            }
            else if(productType == 8)
            {
                // 健康险产品
                that.$router.push({name: "healthInsuranceDetail", query:{id: data.targetId}});
            }
            else
            {
                
                that.$router.push({name:"medical", query:{id: data.targetId, productId: data.id}});
            }
        }
        else {
            // 是否是全部产品
            let isAllProduct = item.type ==  urlTypeMap.AllProduct;
            // that.$router.push({name:"health-product-list"});
            that.$router.push({name: "category", query: { checkedAll: item.checkedAll, isAllProduct }});
        }
        
    }
    else if (item.type ==  urlTypeMap.HealthProduct) {
        // 数据主键id集合
        let ids = [];
        // 数据所属二级类别集合
        let categoryIds = [];
        if (item.dataList && item.dataList.length) {
            item.dataList.forEach(element => {
                ids.push(element.id);
                !categoryIds.includes(element.subProductType) && categoryIds.push(element.subProductType);
            });
            // 全部产品
            localStorage.setItem("productList", JSON.stringify(ids));
            localStorage.setItem("productCategoryIds", JSON.stringify(categoryIds));
        }
        else {
            localStorage.setItem("productList", null);
            localStorage.setItem("productCategoryIds", null);
        }
        if (ids.length === 1) {
            let productType = item.dataList[0].productType;
            let data = item.dataList[0];
            if(productType == 0)
            {
                // 体检套餐
                that.$router.push({name: "package-detail", query:{id: data.targetId, productId: data.id}});
            }
            else if(productType == 4)
            {
                // 实物套餐
                that.$router.push({name: "goodsDetail", query:{id: data.targetId, productId: data.id}});
            }
            else if(productType == 8)
            {
                // 健康险产品
                that.$router.push({name: "healthInsuranceDetail", query:{id: data.targetId}});
            }
            else
            {
                
                that.$router.push({name:"medical", query:{id: data.targetId, productId: data.id}});
            }
        }
        else {
            that.$router.push({name: "category", query: { checkedAll: item.checkedAll }});
        }
    }
    else if (item.type == urlTypeMap.SingleRights)  // 权益商品
    {
        that.$router.push({name:"rights-shop-detail", query:{id: item.dataList[0].id}});
    }
    else if (item.type == urlTypeMap.MultipleRights || item.type == urlTypeMap.AllRights)  // 多个权益
    {
        let ids = [];
        item.dataList && item.dataList.length && item.dataList.forEach(element => {ids.push(element.id);});
        localStorage.setItem("rightsList", JSON.stringify(ids));
        if (ids.length === 1) {
            that.$router.push({name:"rights-shop-detail", query:{id: item.dataList[0].id}});
        }
        else {
            that.$router.push({name:"rights-shop-list"});
        }
        
    }
    else if (item.type == urlTypeMap.PhysicalPackage)  // 体检套餐
    {
        let ids = [];
        item.dataList && item.dataList.length && item.dataList.forEach(element => {ids.push(element.id);});
        localStorage.setItem("physicalPackageList", JSON.stringify(ids));
        if (ids.length === 1) {
            that.$router.push({name: "package-detail", query:{id: item.dataList[0].targetId, productId: item.dataList[0].id}});
        }
        else {
            that.$router.push({name:"physical-package-list"});
        }
    }
    else if (item.type == urlTypeMap.CustomUrl)    // 链接
    {
        var reg = /(http|https):\/\/([\w.]+\/?)\S*/ig;
        if (item.link.match(reg))
        {
            window.location.href = item.link;
        }
        else
        {
            window.location.href = location.protocol + '//' + item.link;
        }
    }
    else if (item.type == urlTypeMap.PhysicalOrder)    // 体检订单
    {
        that.$router.push({ name: "order-list", query: { isPhysical: "1" } });
    }
    else if (item.type == urlTypeMap.ReportManagement)    // 体检报告
    {
        that.$emit("msg", {type: 404});
    }
    else if (item.type == urlTypeMap.HealthRecord)    // 健康档案
    {

    }
    else if (item.type == urlTypeMap.ReportAnalysis)    // 报告解读
    {

    }
    else if (item.type == urlTypeMap.PersonManagement)    // 受检人管理
    {
        that.$router.push({ name: "familyList"});
    }
    else if (item.type == urlTypeMap.PrivacyProtect)    // 隐私保护
    {
        that.$router.push({ name: "login-privacy"});
    }
    else if (item.type == urlTypeMap.Address)    // 收货地址
    {
        that.$router.push({ name: "address-list"});
    }
    else if (item.type == urlTypeMap.Feedback)    // 意见反馈
    {
        that.$router.push({ name: "feedbackList"});
    }
    else if (item.type == urlTypeMap.AccountSetting)    // 账号设置
    {
        that.$router.push({ name: "userSetting"});
    }
    else if (item.type == urlTypeMap.CouponManagement)    // 优惠券管理
    {
        that.$router.push({ name: "coupon-list-manage"});
    }
    else if (item.type == urlTypeMap.ExchangeCenter)    // 兑换中心
    {
        that.$router.push({ name: "rights-redemption-center"});
    }
    else if (item.type == urlTypeMap.CouponInfo)        // 优惠券
    {
        that.$router.push({name: 'coupon-list-info', query:{cid: item.dataList[0].id, from: 'home'}});
    }
}